import React, { useState, useEffect } from 'react';
import Login from './pages/Login';
import Landing from './pages/Landing';
import Dashboard from './pages/Dashboard';
import ResetPassword from './pages/ResetPassword';
import Admin from './pages/Admin';
import Registro from './pages/Registro';
import { getSession, onAuthStateChange } from './lib/auth';

const path = window.location.pathname;
const params = new URLSearchParams(window.location.search);
const token = params.get('token');
const isRecovery = window.location.hash.includes('type=recovery');

export default function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showLogin, setShowLogin] = useState(false);

  useEffect(() => {
    getSession().then(s => {
      setSession(s);
      setLoading(false);
    });
    const { data: { subscription } } = onAuthStateChange(s => setSession(s));
    return () => subscription.unsubscribe();
  }, []);

  if (isRecovery) return <ResetPassword />;
  if (path === '/registro' && token) return <Registro token={token} />;
  if (path === '/admin') return <Admin session={session} />;

  if (loading) return (
    <div style={{ minHeight: '100vh', background: '#0a0c10', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ fontSize: '14px', color: '#6b7280' }}>Cargando...</div>
    </div>
  );

  if (!session) return (
    <>
      <Landing onLogin={() => setShowLogin(true)} />
      {showLogin && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(6px)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ position: 'relative' }}>
            <button onClick={() => setShowLogin(false)} style={{ position: 'absolute', top: '-16px', right: '-16px', background: '#222730', border: 'none', color: '#9ca3af', borderRadius: '50%', width: '32px', height: '32px', fontSize: '16px', cursor: 'pointer', zIndex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✕</button>
            <Login onLogin={(s) => { setSession(s); setShowLogin(false); }} />
          </div>
        </div>
      )}
    </>
  );

  return <Dashboard />;
}